import { CUSTOMERS_TYPES } from "redux/reducers/customers/customersTypes";
import { PROYECT, api_get, api_post, api_put, api_delete } from "services/api";
import axios from "axios";
import {
  setSnackbar,
  startRequest,
  startRequestComp,
  stopRequest,
  stopRequestComp,
} from "../search/searchActions";
import { orderArray } from "helpers/orderArray";
import { addLabelArray } from "helpers/addLabelArray";

import { orderTypes } from "redux/reducers/orders/orderTypes";
import { ActionTypes } from "redux/reducers/liquidations/types";
import { extractIDs } from "helpers/extractIDs";
import { handleUltimateFetchLessData } from "views/Closeouts-Settlements/actions/fetchData";

const {
  REQUEST_CUSTOMER_DATA,
  CATCH_AMAZON_CALL,
  STORE_CALL_ID,
  RESTORE_CALL_ID,
  GET_CUSTOMER_DATA,
  REQUEST_CUSTOMERS,
  GET_CUSTOMERS,
  SET_NEW_CUSTOMER,
  STATIONS_AVAILABLE,
  SELECT_CUSTOMER,
  RESET_CUSTOMER,
  EDIT_CUSTOMER,
  EDIT_CUSTOMER_INFO,
  SELECT_CUSTOMER_ACCOUNT,
  SELECT_ONLY_CUSTOMER_ACCOUNT,

  SELECT_VIEW,

  ADD_ACCOUNT_MODE,
  NEW_ACCOUNT,
  EDIT_ACCOUNT,

  GET_CUSTOMER_SERVICES,
  NEW_CUSTOMER_SERVICES,
  REQUEST_CUSTOMER_SERVICES,
  SET_SERVICE,

  SET_VALID_COUPON,

  SET_SCHEDULES,
  SET_CYCLE_DATE_SCHEDULES,

  SET_PRODUCTS,

  GET_CUSTOMER_CYCLES,
  ADD_CYCLE_MODE,
  CANCEL_CYCLE_MODE,
  CREATE_CYCLE,
  EDIT_ACCOUNT_CYCLE,
  DELETE_ACCOUNT_CYCLE,
  SELECT_CYCLE,

  GET_CUSTOMER_CONDITIONS,
  SET_CUSTOMER_CONDITIONS,
  ADD_CUSTOMER_CONDITION,
  EDIT_CUSTOMER_CONDITION,
  DELETE_CUSTOMER_CONDITION,

  GET_CUSTOMER_CONTRACTS,
  START_LOADING_CONTRACT,
  STOP_LOADING_CONTRACT,

  HIDE_COSTS,
  SET_AMAZON_CONNECT,
  CLEAN_CUSTOMERS,
  RESTORE_INITIAL,
  OPEN_AMAZON_CONNECT,
  SET_MAP_INFO,
  SET_ACCOUNT_CREDIT,
  ERROR_CUSTOMER_CREDIT,
  SET_PUBLIC_ACCOUNT_PRODUCTS,

  SET_DISCOUNT_TYPE,
} = CUSTOMERS_TYPES;
const { SET_ORDER_SCHEDULE } = orderTypes;
const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}`;
const url = `${baseUrl}/customers`;

const mapApiKey = process.env.REACT_APP_MAPS_API_KEY;

const { GET_CUSTOMERS_LIQUIDATIONS } = ActionTypes;
export const getAmazonInfoCall = (data) => {
  return {
    type: CATCH_AMAZON_CALL,
    payload: data,
  };
};

export const setCallID = (callID) => {
  return {
    type: STORE_CALL_ID,
    payload: callID,
  };
};

export const restoreCallID = () => {
  return { type: RESTORE_CALL_ID };
};
export const getCustomers = (search, searchType = "", stations = []) => {
  let filter = "";
  switch (searchType) {
    case "wholesalers":
      filter = `wholesalers?filter=${search}`;
      break;
    case "erp":
      const params = extractIDs(stations)
        .map((id) => `stations=${id}`)
        .join("&");
      filter = `erp?${params}&filter=${search}`;
      break;
    default:
      filter = `?filter=${search}`;
  }

  const getCustomersUrl = `${url}/${filter}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCustomers"));
    dispatch({ type: REQUEST_CUSTOMERS });

    try {
      const customers = await api_get(getCustomersUrl);
      if (customers.length === 0) {
        dispatch(setSnackbar("No se encontraron clientes.", "warning"));
        dispatch({
          type: GET_CUSTOMERS,
          payload: { customers: [], accounts: [], accountInput: search },
        });
        dispatch(stopRequestComp("loadingCustomers"));
        return;
      }
      const accounts = customers.reduce((acc, curr) => {
        acc.push(
          ...curr.accounts.map((account) => ({
            ...account,
            idCustomer: curr.id,
            rfc: curr.rfc,
          }))
        );
        return acc;
      }, []);

      dispatch({
        type: GET_CUSTOMERS,
        payload: {
          customers,
          accounts: addLabelArray(accounts, "alias"),
          accountInput: search,
        },
      });
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("loadingCustomers"));
  };
};

export const getAccountData = (idCustomer, code, idAccount) => {
  const getAccountsUrl = `${url}?filter=${code}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCustomer"));
    try {
      const resp = await api_get(getAccountsUrl);
      const customer = resp.find((acc) => acc.id === idCustomer);
      const account = customer.accounts.find((acc) => acc.id === idAccount);
      const payload = {
        ...customer,
        accounts: [account],
      };
      dispatch({
        type: GET_CUSTOMER_DATA,
        payload,
      });
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp("loadingCustomer"));
  };
};

export const registerNewCustomer = (form, close = null) => {
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCustomerCrud"));
    try {
      const resp = await api_post(url, form);
      const customer = resp[0];
      const createAccountCustomerUrl = `${url}/${customer.id}/accounts`;
      const newForm = {
        ...customer,
        localPhone: customer.phone,
        idCustomer: customer.id,
        type: form.type,
        segment: form.segment,
        subsegment: form.subsegment,
      };
      const getCustomersUrl = `${url}/${customer.id}`;
      await api_post(createAccountCustomerUrl, newForm);
      const customerData = await api_get(getCustomersUrl);
      dispatch({
        type: SET_NEW_CUSTOMER,
        payload: { ...customerData[0], isNew: true, idCustomer: customer.id },
      });
      dispatch(setSnackbar(`Cliente creado con éxito`, "success"));
      close && close();
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp("loadingCustomerCrud"));
  };
};

export const getStationsByPostalCode = (
  code,
  close = null,
  confirm = null,
  isByToken = false
) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/postal_codes/${code}`;
  return async (dispatch) => {
    try {
      const stations = await api_get(url);
      const stationsLabel = stations.map((sta) => {
        return {
          ...sta,
          label: `${sta.name} - ${sta.company}`,
          value: sta.id,
        };
      });
      !isByToken && dispatch(setStationsAvailable(stationsLabel));
      close && close();
      close && confirm();
    } catch (error) {
      dispatch(setSnackbar(error));
      return [];
    }
  };
};

export const setStationsAvailable = (data) => {
  return { type: STATIONS_AVAILABLE, payload: data };
};

export const getCustomerData = (idCustomer) => {
  const getCustomersUrl = `${url}/${idCustomer}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCustomer"));
    dispatch({ type: REQUEST_CUSTOMER_DATA });
    try {
      const resp = await api_get(getCustomersUrl);
      dispatch({
        type: GET_CUSTOMER_DATA,
        payload: resp[0],
      });
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp("loadingCustomer"));
  };
};

export const editCustomerInfo = (idCustomer, form) => {
  const editCustomersUrl = `${url}/${idCustomer}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCustomerCrud"));
    try {
      const resp = await api_put(editCustomersUrl, form);
      dispatch({
        type: EDIT_CUSTOMER_INFO,
        payload: resp,
      });
      dispatch(setSnackbar(`Cliente editado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp("loadingCustomerCrud"));
  };
};

export const getCustomerServices = (idCustomer) => {
  const getCustomersUrl = `${url}/${idCustomer}/services`;
  return async (dispatch) => {
    dispatch(startRequest());
    dispatch({ type: REQUEST_CUSTOMER_SERVICES });
    try {
      const resp = await api_get(getCustomersUrl);
      dispatch({
        type: GET_CUSTOMER_SERVICES,
        payload: resp,
      });
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequest());
  };
};

export const newCustomerService = (form, back) => {
  const newtServiceUrl = `${process.env.REACT_APP_URL}${PROYECT}/services`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCreateOrder"));
    dispatch({ type: REQUEST_CUSTOMER_SERVICES });
    try {
      const resp = await api_post(newtServiceUrl, form);
      dispatch({
        type: NEW_CUSTOMER_SERVICES,
        payload: resp,
      });
      dispatch(setSnackbar("Pedido realizado con éxito", "success"));
      back();
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp("loadingCreateOrder"));
  };
};

export const checkCoupon = (form, back) => {
  return async (dispatch) => {
    try {
      dispatch(startRequestComp('loadingValidateCoupon'))
    
      const resp = await api_post(`${process.env.REACT_APP_URL}${PROYECT}/coupons/validate`, form)
      dispatch({
        type: SET_VALID_COUPON,
        payload: resp
      })
      if (back) back()
    } catch (err) {
      dispatch({
        type: SET_VALID_COUPON,
        payload: {}
      })
      dispatch(setSnackbar(err))
    } finally {
      dispatch(stopRequestComp('loadingValidateCoupon'))
    }

  }
}

export const selectCustomerOrder = idService => {
  return {
    type: SET_SERVICE,
    payload: idService,
  };
};

export const selectCustomerAccount = (account, view = 0) => {
  return {
    type: SELECT_CUSTOMER_ACCOUNT,
    payload: { account, view },
  };
};

export const selectOnlyCustomerAccount = (account) => {
  return {
    type: SELECT_ONLY_CUSTOMER_ACCOUNT,
    payload: account,
  };
};

export const createNewCustomer = (form) => {
  const createCustomerUrl = `${url}`;
  return async (dispatch) => {
    dispatch(startRequestComp());
    try {
      await api_post(createCustomerUrl, form);
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp());
  };
};

export const getSchedules = (stationId, date = null, isOrder = null) => {
  const schedulesUrl = `${process.env.REACT_APP_URL}${PROYECT}/stations/${stationId}/schedules${date ? "/" + date : ""}`;
  return async (dispatch) => {
    try {
      const resp = await api_get(schedulesUrl);
      if (date) {
        dispatch({
          type: SET_CYCLE_DATE_SCHEDULES,
          payload: resp,
        });
      } else if (isOrder) {
        dispatch({
          type: SET_ORDER_SCHEDULE,
          payload: resp,
        });
      } else {
        dispatch({
          type: SET_SCHEDULES,
          payload: resp,
        });
      }
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const getCustomerProducts = (accountId, props = {}) => {
  const productsUrl = `${process.env.REACT_APP_URL}${PROYECT}/accounts/${accountId}/products`;
  return async (dispatch) => {
    try {
      const resp = await api_get(productsUrl);
      dispatch({
        type: SET_PRODUCTS,
        payload: orderArray(resp, "product"),
      });
    } catch (error) {
      const { stations, customerIdStation } = props && props;
      const officialErrorPrice = error
        ?.toLowerCase()
        .includes("no existen precios oficiales");
      if (officialErrorPrice) {
        const params = stations
          .map((station) => `stations=${station.id}`)
          .join("&");
        const url = `${process.env.REACT_APP_URL}${PROYECT}/accounts/search-less-data?${params}&filter=public`;
        const response = await api_get(url);
        if (!response) return;
        const findOne = response.find(
          (account) => account.idStation === customerIdStation
        );
        dispatch(getCustomerProducts(findOne?.idAccount));
      } else {
        dispatch({
          type: SET_PRODUCTS,
          payload: [],
        });
        dispatch(setSnackbar(error));
      }
    }
    dispatch(stopRequestComp("loadingCustomerNavigation"));
  };
};

export const createAccount = (idCustomer = "", form, close = null) => {
  const createAccountUrl = `${url}/${idCustomer}/accounts`;
  return async (dispatch) => {
    try {
      const resp = await api_post(createAccountUrl, form);
      dispatch({
        type: NEW_ACCOUNT,
        payload: { ...resp, label: resp.alias, value: resp.id },
      });
      dispatch(selectCustomerAccount({}, 1));
      dispatch(
        setSnackbar(`Cuenta - ${resp.alias} - agregada con éxito`, "success")
      );
      close && close();
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const editAccount = (
  idCustomer = "",
  idAccount = "",
  form,
  close = null
) => {
  const editAccountUrl = `${url}/${idCustomer}/accounts/${idAccount}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCustomerCrud"));
    try {
      const resp = await api_put(editAccountUrl, form);
      dispatch({
        type: EDIT_ACCOUNT,
        payload: resp,
      });
      dispatch(
        setSnackbar(`Cuenta - ${resp.alias} - editada con éxito`, "success")
      );
      close && close();
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp("loadingCustomerCrud"));
  };
};

export const getCustomerCyclesType = () => {
  const cyclesUrl = `${process.env.REACT_APP_URL}${PROYECT}/accounts/cycles/types`;
  return async (dispatch) => {
    try {
      const resp = await api_get(cyclesUrl);
      dispatch({
        type: GET_CUSTOMER_CYCLES,
        payload: resp,
      });
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const createCustomerCycle = (idAccount, form, cleanForm = null) => {
  const urlCreateCycle = `${process.env.REACT_APP_URL}${PROYECT}/accounts/${idAccount}/cycles`;
  return async (dispatch, getState) => {
    try {
      const resp = await api_post(urlCreateCycle, form);
      const customerId = getState().customersReducer.customer?.id;
      
      if (customerId) {
        await dispatch(getCustomerData(customerId));
      }
      
      dispatch(setSnackbar("Ciclo creado con éxito", "success"));
      cleanForm && cleanForm();
      dispatch(cancelAddCycleMode());
      return true;
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const editCustomerCycle = (
  idAccount,
  idCycle,
  form,
  cleanForm = null
) => {
  const urlEditCycle = `${process.env.REACT_APP_URL}${PROYECT}/accounts/${idAccount}/cycles/${idCycle}`;
  return async (dispatch) => {
    try {
      const resp = await api_put(urlEditCycle, form);
      dispatch({
        type: EDIT_ACCOUNT_CYCLE,
        payload: { ...resp, idAccount: idAccount },
      });
      dispatch(setSnackbar("Ciclo editado con éxito", "success"));
      cleanForm && cleanForm();
      dispatch(cancelAddCycleMode());
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const deleteCustomerCycle = (
  idAccount,
  idCycle,
  cleanForm = null
) => {
  const urlDeleteCycle = `${process.env.REACT_APP_URL}${PROYECT}/accounts/cycles/${idCycle}`;
  return async (dispatch) => {
    try {
      await api_delete(urlDeleteCycle);
      dispatch({
        type: DELETE_ACCOUNT_CYCLE,
        payload: { idAccount, cycleId: idCycle },
      });
      dispatch(setSnackbar("Ciclo cancelado con éxito", "success"));
      cleanForm && cleanForm();
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const getCustomerConditions = (idCustomer) => {
  const urlCustomerConditions = `${process.env.REACT_APP_URL}${PROYECT}/customers/${idCustomer}/customers-conditions`;
  return async (dispatch) => {
    try {
      const resp = await api_get(urlCustomerConditions);
      dispatch({
        type: GET_CUSTOMER_CONDITIONS,
        payload: resp,
      });
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

// PUT /crm/customers/:id/customers-conditions
// Los 5 campos son obligatorios para el backend: los que no tengan valor se
// envían en 0 (o false para isCreditNote). La respuesta solo trae un mensaje
// de confirmación (sin el objeto actualizado), así que en vez de pedir el
// GET de nuevo, se actualiza `customerConditions` en el store con los
// mismos datos que ya se mandaron en el form (evita el round-trip extra).
export const updateCustomerCreditConditions = (idCustomer, form, action = null) => {
  const urlCustomerConditions = `${process.env.REACT_APP_URL}${PROYECT}/customers/${idCustomer}/customers-conditions`;
  return async (dispatch, getState) => {
    dispatch(startRequestComp("loadingCustomerCrud"));
    try {
      const resp = await api_put(urlCustomerConditions, form);
      dispatch(setSnackbar(resp?.message || "Condiciones comerciales actualizadas.", "success"));
      const { customerConditions } = getState().customersReducer;
      dispatch({
        type: SET_CUSTOMER_CONDITIONS,
        payload: {
          ...customerConditions,
          credit: form.credit,
          creditDays: form.creditDays,
          discount: form.discount,
          volume: form.agreedVolume,
          maxMonthlyConsumption: form.maxMonthlyConsumption,
          isCreditNote: form.isCreditNote,
        },
      });
      action && action();
    } catch (err) {
      dispatch(setSnackbar(err));
    }
    dispatch(stopRequestComp("loadingCustomerCrud"));
  };
};

export const addCustomerCondition = (idCustomer, form, action = null) => {
  const urlConditionCustomer = `${process.env.REACT_APP_URL}${PROYECT}/customers/${idCustomer}/customer-conditions`;
  return async (dispatch) => {
    try {
      const resp = await api_post(urlConditionCustomer, form);
      dispatch({
        type: ADD_CUSTOMER_CONDITION,
        payload: resp,
      });
      dispatch(setSnackbar("Guardado", "success"));
      action && action();
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const editConditionCustomer = (customerId, conditionId, form) => {
  const urlEditCondition = `${process.env.REACT_APP_URL}${PROYECT}/customers/${customerId}/conditions/${conditionId}`;
  return async (dispatch) => {
    try {
      const resp = await api_put(urlEditCondition, form);
      dispatch({
        type: EDIT_CUSTOMER_CONDITION,
        payload: resp,
      });
      dispatch(setSnackbar(resp?.message, "success"));
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const removeConditionCustomer = (customerId, conditionId) => {
  const urlDeleteCondition = `${process.env.REACT_APP_URL}${PROYECT}/customers/${customerId}/customers-conditions/${conditionId}`;
  return async (dispatch) => {
    try {
      const resp = await api_delete(urlDeleteCondition);
      dispatch({
        type: DELETE_CUSTOMER_CONDITION,
        payload: conditionId,
      });
      dispatch(setSnackbar(resp?.message, "success"));
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const getCustomerContracts = (customerId) => {
  const urlContracts = `${url}/${customerId}/contracts`;
  return async (dispatch) => {
    try {
      const resp = await api_get(urlContracts);
      dispatch({
        type: GET_CUSTOMER_CONTRACTS,
        payload: resp,
      });
    } catch (err) {
      dispatch(setSnackbar(err));
    }
  };
};

export const uploadCustomerContract = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/contract-files`;
  const auth = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    },
  };

  return async (dispatch) => {
    dispatch({
      type: START_LOADING_CONTRACT,
    });
    try {
      const resp = await axios.post(url, form, auth);
      dispatch(setSnackbar(resp.data.message, "success"));
      setTimeout(() => {
        dispatch(getCustomerContracts(id));
      }, 2000);
    } catch (error) {
      dispatch(setSnackbar(error || "Error al cargar el archivo:"));
    }
    dispatch({
      type: STOP_LOADING_CONTRACT,
    });
  };
};

export const selectCustomer = (customer) => {
  return {
    type: SELECT_CUSTOMER,
    payload: customer,
  };
};

export const resetCustomer = () => {
  return {
    type: RESET_CUSTOMER,
  };
};

export const editCustomerMode = (value) => {
  return {
    type: EDIT_CUSTOMER,
    payload: value,
  };
};

export const selectCustomerCycle = (cycle) => {
  return {
    type: SELECT_CYCLE,
    payload: cycle,
  };
};

export const addAccountMode = () => {
  return {
    type: ADD_ACCOUNT_MODE,
  };
};

export const activeAddCycleMode = () => {
  return {
    type: ADD_CYCLE_MODE,
  };
};

export const cancelAddCycleMode = () => {
  return {
    type: CANCEL_CYCLE_MODE,
  };
};

export const hideCostAction = (id, display) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/hideCosts?display=${display}`;
  return async (dispatch) => {
    try {
      const resp = await api_put(url);
      dispatch({
        type: HIDE_COSTS,
        payload: resp.hideCosts,
      });
    } catch (error) {
      dispatch(setSnackbar(error));
    }
  };
};

export const selectView = (count) => {
  return {
    type: SELECT_VIEW,
    payload: count,
  };
};

export const setUrlAmazonConnect = (url) => {
  return { type: SET_AMAZON_CONNECT, payload: url };
};

export const cleanCustomers = () => {
  return (dispatch) => {
    dispatch(setSnackbar("Búsqueda limpiada.", "success"));
    dispatch({ type: CLEAN_CUSTOMERS });
  };
};

export const restoreInitial = () => {
  return { type: RESTORE_INITIAL };
};

export const handleOpenAmazonConnect = (open = null) => {
  return { type: OPEN_AMAZON_CONNECT, payload: open };
};

export const getMapByCoordinates = (lat, lng) => {
  const urlMap = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${mapApiKey}`;
  return async (dispatch) => {
    try {
      const resp = await axios.get(urlMap);
      const { address_components, geometry } = resp.data.results[0];
      dispatch({
        type: SET_MAP_INFO,
        payload: {
          address: address_components,
          location: geometry.location,
        },
      });
    } catch (err) {
      dispatch(setSnackbar(err || "Coordenadas Invalidas"));
    }
  };
};

export const getCreditAccount = (id, isTableView = false, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/accounts/${id}/credit-account`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCreditAccount"));
    try {
      const resp = await api_get(url);
      dispatch({
        type: SET_ACCOUNT_CREDIT,
        payload: {
          id,
          response: resp,
          isTableView,
        },
      });
      action && action();
    } catch (error) {
      dispatch({ type: ERROR_CUSTOMER_CREDIT, payload: { id, isTableView } });
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("loadingCreditAccount"));
  }
}

export const updateDiscountType = (id, form, action=null) => {
  const newtServiceUrl = `${url}/${id}/discount-type`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingCustomers'))
    try {
      const resp = await api_put(newtServiceUrl, form)
      dispatch({
        type: SET_DISCOUNT_TYPE,
        payload: form.discountType
      })
      dispatch(setSnackbar(resp, 'success'))
      action && action()
    } catch (err) {
      dispatch(setSnackbar(err))
    }
    dispatch(stopRequestComp('loadingCustomers'))
  }
}
